const pathUrl = {
    baseUrl:"https://db.idrblab.net",
    // baseUrl:"http://127.0.0.1:8000",
    // localUrl:"http://success_rate.idrblab.cn",
}

export default pathUrl;